import 'common/styles/markdown.scss';

/**
 * Components related to Availability Showcase
 */

import componentLoader from 'utils/component_loader';
import PageColors from 'page_colors';
import HistoryIndex from 'components/status/history_index';
import UptimeCalendar from 'components/status/uptime_calendar';

window.pageColors = new PageColors(window.pageColorData);

componentLoader({
  HistoryIndex,
  UptimeCalendar,
});

